import { render, staticRenderFns } from "./data-xieyi.vue?vue&type=template&id=28132ee4&"
import script from "./data-xieyi.vue?vue&type=script&lang=js&"
export * from "./data-xieyi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports